<template>
  <div>
    <b-modal
      id="exportingProgress"
      hide-footer
      hide-header
      size="lg"
      :scrollable="false"
    >
      <ExportProgress />
    </b-modal>

    <PageHeader className="d-flex align-items-center " :title="title">
      <b-button
        @click="startSessionModal()"
        pill
        class="d-flex align-items-center justify-content-center text-center session-btn"
        variant="primary"
        size="sm"
      >
        {{ $t("emergencyList.form.startSession") }}
      </b-button>
    </PageHeader>

    <div v-if="this.activeSessions.length" class="active-sessions-con">
      <p class="active-title">{{ $t("emergencyList.activeSessions") }}</p>
      <div class="all-active-btns d-flex">
        <button
          v-for="(session, i) in this.activeSessions"
          :key="i"
          @click="viewSessionData(session.id, session.name)"
          :id="session.id"
          class="first-btn"
        >
          {{ session.name }}
          <b-tooltip
            id="emergency-tooltip"
            :target="session.id"
            triggers="hover"
            placement="bottom"
          >
            <ul>
              <li v-if="session.type">{{ session.type }}</li>
              <li class="emergency-tool-line"></li>
              <li>{{ $t("common.admin") }} - {{ session.fullName }}</li>
            </ul>
          </b-tooltip>
        </button>
      </div>
    </div>
    <!-- grid -->
    <section
      class="emergency-list-table emergency-list-white-bg-sec"
      style="background-color: white"
    >
      <div>
        <h6 class="hint-grid">{{ $t("emergencyList.grid.message") }}</h6>
      </div>

      <DxDataGrid
        id="gridContainerr"
        :data-source="rowsData"
        :ref="dataGridRefName"
        :remote-operations="false"
        :showBorders="false"
        :columnAutoWidth="true"
        :allowColumnReordering="true"
        :allowColumnResizing="true"
        :rowAlternationEnabled="false"
        :showColumnLines="true"
        :showRowLines="true"
        :repaint-changes-only="true"
        :two-way-binding-enabled="true"
        :no-data-text="gridEmptyMessage"
        @content-ready="contentReady($event)"
        @editor-preparing="onEditorPreparing($event)"
        @data-error-occurred="onDataErrorOccurred($event)"
        :rtl-enabled="rtlEnabled"
      >
        <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />

        <DxStateStoring
          :enabled="true"
          type="custom"
          :customSave="customSave"
          :customLoad="customLoad"
        />

        <DxFilterRow :visible="true" />

        <DxHeaderFilter :visible="true" />

        <DxColumnChooser
          :enabled="true"
          mode="select"
          :title="$t('common.grid.columnChooser')"
        />

        <DxToolbar>
          <DxItem location="before" template="columnButtonTemplate" />
          <DxItem location="before" template="exportButtonTemplate" />
          <DxItem location="before" template="clearAllTemplate" />
        </DxToolbar>

        <DxColumn
          data-field="image"
          :caption="$t('common.image')"
          cell-template="image-cell"
          :allow-filtering="false"
          :allow-editing="false"
          :show-in-column-chooser="true"
          alignment="center"
          css-class="image-index"
          :allow-exporting="false"
          :visible="true"
        />

        <DxColumn
          data-field="fullName"
          :caption="$t('common.fullName')"
          :allow-header-filtering="false"
          :filter-operations="allowedOperations"
          :visible="true"
          :width="200"
        />

        <DxColumn
          data-field="phone"
          :caption="$t('common.phoneNumber')"
          :allow-header-filtering="false"
          :filter-operations="allowedOperations"
          :visible="true"
        />

        <DxColumn
          data-field="userType"
          :caption="$t('common.userType')"
          :allow-editing="false"
          :visible="true"
          :allow-filtering="false"
          :allow-header-filtering="true"
        />

        <DxColumn
          data-field="site"
          :caption="$t('common.site')"
          :allow-filtering="false"
          :allow-header-filtering="true"
          :allow-editing="false"
          :visible="true"
        />

        <DxColumn
          data-field="area"
          :caption="$t('common.area')"
          :allow-filtering="false"
          :allow-header-filtering="true"
          :allow-editing="false"
          :visible="true"
        />

        <DxColumn
          data-field="host"
          :caption="$t('common.host')"
          :allow-filtering="true"
          :allow-exporting="true"
          :allow-editing="false"
          :visible="isFlowHasHost || isUserHasHost"
          :width="200"
        />

        <DxColumn
          data-field="status"
          :caption="$t('common.status')"
          :allow-editing="false"
          :visible="true"
          :allow-filtering="false"
          :allow-header-filtering="false"
          cell-template="status-cell"
          :allow-exporting="false"
        />

        <DxColumn
          data-field="present"
          :caption="$t('emergencyList.grid.present')"
          :allow-editing="false"
          :visible="false"
          :allow-filtering="false"
          :allow-header-filtering="false"
          :allow-exporting="true"
          :showInColumnChooser="false"
        />

        <DxColumn
          data-field="notPresent"
          :caption="$t('emergencyList.grid.notPresent')"
          :allow-editing="false"
          :visible="false"
          :allow-filtering="false"
          :allow-header-filtering="false"
          :showInColumnChooser="false"
          :allow-exporting="true"
        />

        <DxColumn
          data-field="out"
          :caption="$t('emergencyList.grid.out')"
          :allow-editing="false"
          :visible="false"
          :allow-filtering="false"
          :allow-header-filtering="false"
          :showInColumnChooser="false"
          :allow-exporting="true"
        />

        <DxColumn
          data-field="by"
          :caption="$t('common.by')"
          :allow-filtering="false"
          :allow-exporting="true"
          :allow-editing="false"
          :width="200"
          :visible="true"
          css-class="select-actions select-actionsDAsh"
        />

        <DxColumn
          data-field="email"
          :caption="$t('common.emailAddress')"
          :allow-header-filtering="false"
          :allow-exporting="true"
          :filter-operations="allowedOperations"
          :visible="true"
          :width="200"
        />

        <DxColumn
          data-field="rfid"
          :min-width="150"
          :caption="$t('common.RFID')"
          :allow-header-filtering="false"
          :allow-sorting="false"
          :filter-operations="allowedOperations"
          :visible="true"
          :allow-exporting="true"
          cell-template="rfid-template"
        />

        <template #rfid-template="{ data }">
          {{ data.data.rfid ? data.data.rfid : "-" }}
        </template>

        <DxColumn
          data-field="user_id"
          :caption="$t('common.id')"
          :allow-header-filtering="false"
          :allow-exporting="true"
          :filter-operations="allowedOperations"
          :allow-editing="false"
          :width="200"
          :visible="false"
        />

        <template #image-cell="{ data }">
          <div v-viewer class="images dash-img clearfix">
            <ImageCell
              v-if="!data.data.image"
              :image="data.data.image"
              :name="data.data.fullName ? data.data.fullName.charAt(0) : ''"
            />

            <img
              class="img-fluid rounded-circle"
              v-if="data.data.image"
              style="cursor: pointer"
              :src="data.data.image"
            />
          </div>
        </template>

        <template #status-cell>
          <div class="d-flex align-items-center">
            <b-form-group class="mb-0">
              <b-form-radio-group :options="options" disabled />
            </b-form-group>
          </div>
        </template>

        <template #exportButtonTemplate>
          <!-- <DxDropDownButton
                        :items="buttonData"
                        text="Export"
                        @item-click="serverSideExport"
                    /> -->

          <DxDropDownButton
            :items="buttonData"
            class="export-dropdown"
            :text="$t('common.grid.export')"
            @item-click="onItemClick"
          />
        </template>

        <template #columnButtonTemplate>
          <button class="custom-columns" @click="dataGrid.showColumnChooser()">
            <span class="custom-text">{{ $t("common.grid.columns") }}</span>
            <span class="custom-icon">
              <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
            </span>
          </button>
        </template>

        <template #clearAllTemplate>
          <div v-if="showClearAll" class="clear-cols d-flex align-items-center">
            <div class="toolbar-custom-line"></div>
            <Button
              :text="$t('common.grid.clearFilters')"
              @click="reset()"
              styling-mode="outlined"
              type="danger"
              class="clear-CustomColums"
            />
          </div>
        </template>
      </DxDataGrid>
    </section>

    <!-- Start Sessin Modal  -->
    <startSessionForm />
  </div>
</template>

<script>
const dataGridRefName = "dataGridEmergencyList";
import { mapActions, mapGetters } from "vuex";
import PageHeader from "../../../components/page-header.vue";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { emergencyListColumns } from "@/utils/dataSource";
import ImageCell from "@/components/sharedCells/ImageCell";
import startSessionForm from "@/components/emergency/startSession";
import ExportProgress from "@/components/grid/ExportProgress";
import { default as Button } from "devextreme-vue/button";
import { exportDataGrid } from "devextreme/excel_exporter";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
import { Workbook } from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import saveAs from "file-saver";
import { rfidFormatterMixin } from "@/utils/mixins/rfidFormatterMixin";
import amiriFont from "@/assets/fonts/Amiri-Regular.ttf"; // Load the Cairo font

import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxHeaderFilter,
  DxColumnChooser,
  DxToolbar,
  DxItem,
  DxStateStoring,
  DxScrolling,
} from "devextreme-vue/data-grid";
export default {
  name: "EmergencyList",
  title: "Emergency List",
  mixins: [rfidFormatterMixin],
  components: {
    PageHeader,
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxHeaderFilter,
    DxColumnChooser,
    DxToolbar,
    DxItem,
    DxDropDownButton,
    ImageCell,
    DxStateStoring,
    startSessionForm,
    ExportProgress,
    Button,
    DxScrolling,
  },
  data() {
    return {
      // title : "Emergency List",
      gridEmptyMessage : this.$t('common.grid.loadingData'),
      rtlEnabled: false,
      dataGridRefName,
      allowedOperations: ["contains"],
      selectedOperation: "contains", // default icon
      buttonData: ["Excel", "CSV", "PDF"],
      emergencyListColumns: emergencyListColumns,
      activeSessions: [],
      options: [
        { text: this.$t("emergencyList.grid.present") },
        { text: this.$t("emergencyList.grid.notPresent") },
        { text: this.$t("emergencyList.grid.out") },
      ],
      isFlowHasHost: false,
      isUserHasHost: false,
      showClearAll: false,
      emergecyListData: [],
    };
  },
  methods: {
    ...mapActions("grid", [
      "onTableHeader",
      "updateTableHeaders",
      "createTableHeaders",
      "onSetLoading",
      "exportJobBE",
      "checkVaccinePCRColumnAppearance",
    ]),
    ...mapActions("emergency", [
      "getAll",
      "fetchGridEmergencyListData",
      "fetchActiveSessionsData",
      "getSessionPage",
    ]),
    fetchTableHeaders() {
      this.onTableHeader({
        url: "/emergency-manual-list",
        headers: emergencyListColumns,
      });
    },
    onToggleVisible() {
      this.$bvModal.show("emergencyListColumns");
    },
    contentReady(e) {
      let sortedExp = this.getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      this.setColumnChooserPosition();
    },
    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.dataGrid.columnCount()).keys()
      ).map((index) => this.dataGrid.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },
    setColumnChooserPosition() {
      var columnChooserView = this.dataGrid.getView("columnChooserView");
      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }
      columnChooserView._popupContainer.option("position", {
        of: this.dataGrid.element(),
        my: this.rtlEnabled ? "right top" : "left top",
        at: this.rtlEnabled ? "right top" : "left top",
        offset: "0 50",
      });
    },
    async customLoad() {
      if (this.userEmail != "lt_techteam@visipoint.com") {
        await this.onTableHeader({
          url: "/emergency-manual-list",
        });
        let value = this.getTableHeaders;
        console.log("customLoad");
        return value;
      }
    },
    customSave(gridState) {
      if (this.userEmail != "lt_techteam@visipoint.com") {
        gridState.pageIndex = 0;
        gridState.pageSize = 1000000;
        let value = JSON.stringify(gridState);
        value = value.replace(',"selectedRowKeys":[]', "");
        if (!this.getTableHeaders) {
          this.createTableHeaders({
            url: "/emergency-manual-list",
            headers: value,
            filters: "[]",
          });
        } else if (value != JSON.stringify(this.getTableHeaders)) {
          this.updateTableHeaders({
            url: "/emergency-manual-list",
            headers: value,
            filters: "[]",
          });
        }
        console.log(
          "customSave values",
          value != JSON.stringify(this.getTableHeaders)
        );
      }
    },
    onEditorPreparing(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
    },
    startSessionModal() {
      setTimeout(() => {
        const selectAllText = document.querySelector(
          ".dx-treeview-select-all-item .dx-checkbox-text"
        );
        if (selectAllText) selectAllText.innerHTML = "All";
      }, 110);
      this.$bvModal.show("startSessionModal");
    },
    viewSessionData(id, name) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";
      // this.getSessionPage({ id, name, redirect: true });
      this.$router.push({ path: `/emergency-sessions/${name}/${id}` });
    },
    async serverSideExport(e) {
      // console.log(e);
      await this.dataGrid.columnOption("Present", "visible", true);
      await this.dataGrid.columnOption("Not Present", "visible", true);
      await this.dataGrid.columnOption("Out", "visible", true);

      const columnNames = this.dataGrid.getVisibleColumns();
      const columns = [];
      for (let i = 0; i < columnNames.length; i++) {
        if (columnNames[i].allowExporting) {
          columns.push(columnNames[i].caption);
        }
      }

      await this.exportJobBE({
        type: e.itemData,
        headers: columns.reduce((accumulator, value) => {
          return { ...accumulator, [value]: value };
        }, {}),
        gridName: "emergency",
        entity_id: this.currentEntity.id,
        filterBy: {},
        orderBy: {
          sortField: null,
          sortOrder: null,
        },
      });
      this.dataGrid.columnOption("Present", "visible", false);
      this.dataGrid.columnOption("Not Present", "visible", false);
      this.dataGrid.columnOption("Out", "visible", false);

      this.dataGrid.endUpdate();
    },
    async onItemClick(e) {
      await this.dataGrid.columnOption("Present", "visible", true);
      await this.dataGrid.columnOption("Not Present", "visible", true);
      await this.dataGrid.columnOption("Out", "visible", true);
      e.rtlEnabled = this.rtlEnabled;
      if (e.itemData == "Excel") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        await exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Emergency Manual List.xlsx"
            );
          });
        });
        // e.cancel = true;
      } else if (e.itemData == "CSV") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        await exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.csv.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Emergency Manual List.csv"
            );
          });
        });
      } else if (e.itemData == "PDF") {
        const doc = new jsPDF('landscape');

        // Add custom font
        doc.addFont(amiriFont, "Amiri", "normal");
        doc.setFont("Amiri");


        doc.autoTable({ direction: "rtl" });

        await exportDataGridToPdf({
          jsPDFDocument: doc,
          component: this.dataGrid,
          customizeCell: function (options) {
            const { gridCell, pdfCell } = options;
            if (gridCell.rowType === "data") {
              // data columns style
              pdfCell.styles = {
                font: e.rtlEnabled ? "Amiri" : "Lato",
                fontStyle: "normal",
                fontSize: 8,
                cellWidth: "auto",
                halign: "center",
              };
            } else {
              // header columns style
              pdfCell.styles = {
                font: e.rtlEnabled ? "Amiri" : "Lato",
                fontStyle: "normal",
                fontSize: 8,
                fillColor: "#2680EB",
                textColor: "#FFFFFF",
                cellWidth: "auto",
                halign: "center", 
              };
            }
          },
          customizeTable: (doc) => {
            doc.autoTable({ direction: "rtl" }); // Ensure table follows RTL direction
          },
        }).then(() => {
          const pageCount = doc.internal.getNumberOfPages();
          for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            const pageSize = doc.internal.pageSize;
            const pageWidth = pageSize.width
              ? pageSize.width
              : pageSize.getWidth();
            const pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
            const header = this.$t("emergencyList.grid.title");
            const headerWidth = doc.getTextDimensions(header).w;
            const footer = `${this.$t("common.page")} ${i} ${this.$t("common.of")} ${pageCount}`;

            // Header
            doc.text(header, (pageWidth - headerWidth) / 2, 10);

            // Footer
            doc.text(
              footer,
              pageWidth / 2 - doc.getTextWidth(footer) / 2,
              pageHeight - 5,
              { baseline: "bottom" }
            );
          }

          doc.save("Emergency Manual List.pdf");
        });
      }

      await this.dataGrid.columnOption("Present", "visible", false);
      await this.dataGrid.columnOption("Not Present", "visible", false);
      await this.dataGrid.columnOption("Out", "visible", false);
    },
    // onItemClick(e) {
    //     if (e.itemData == "Excel") this.exportXLSX();
    //     else if (e.itemData == "CSV") this.exportCSV();
    //     else if (e.itemData == "PDF") this.exportPDF();
    // },
    // async exportPDF() {

    //     this.dataGrid.columnOption("Present", "visible", true);
    //     this.dataGrid.columnOption("Not Present", "visible", true);
    //     this.dataGrid.columnOption("Out", "visible", true);

    //     await this.getAll({
    //         sortObject: this.sortObject,
    //         finalFilterObject: this.finalFilterObject,
    //         limit: this.totalCount,
    //         isExporting: true,
    //     });
    //     const columnNames = this.dataGrid.getVisibleColumns();
    //     const columns = [];
    //     for (let i = 0; i < columnNames.length; i++) {
    //         if (columnNames[i].allowExporting)
    //         columns.push(columnNames[i].caption);
    //     }
    //     const doc = new jsPDF("landscape");
    //     // this.onSetLoading({ value: true });
    //     const { extractedData } = this;
    //     const headers = columns;
    //     this.pdfTableHeaders = headers;
    //     doc.autoTable({
    //         columns: this.pdfTableHeaders,
    //         body: extractedData("pdf"),
    //         styles: {
    //         fontSize: this.onSetPdfFont(this.pdfTableHeaders.length),
    //         cellWidth: "wrap",
    //         },
    //         didParseCell: (data) => {
    //         if (
    //             data.column.index === 0 &&
    //             data.cell.section === "body" &&
    //             headers.includes("Image")
    //         ) {
    //             data.cell.styles.minCellHeight = 10;
    //             data.cell.styles.minCellWidth = 10;
    //             data.cell.text = "";
    //         }
    //         },
    //         didDrawCell: (data) => {

    //         // Header
    //         doc.setFontSize(15);
    //         doc.text("Emergency Manual List", 10, 10);

    //         if (
    //             data.column.index === 0 &&
    //             data.cell.section === "body" &&
    //             data.row.raw[0] != null
    //         ) {

    //             doc.addImage(
    //             data.row.raw[0],
    //             "JPEG",
    //             data.cell.x + 2,
    //             data.cell.y + 2,
    //             5,
    //             5
    //             );
    //         }
    //         },
    //     });

    //     this.dataGrid.columnOption("Present", "visible", false);
    //     this.dataGrid.columnOption("Not Present", "visible", false);
    //     this.dataGrid.columnOption("Out", "visible", false);

    //     this.dataGrid.endUpdate();
    //     doc.save("Emergency-Manual-List.pdf");

    // },
    // exportXLSX() {
    //     this.isExport = true;
    //     const workbook = new Workbook();
    //     const worksheet = workbook.addWorksheet("Main sheet");

    //     this.dataGrid.columnOption("Present", "visible", true);
    //     this.dataGrid.columnOption("Not Present", "visible", true);
    //     this.dataGrid.columnOption("Out", "visible", true);

    // exportDataGrid({
    //     component: this.dataGrid,
    //     worksheet,
    //     autoFilterEnabled: true,
    //     // topLeftCell: { row: 2, column: 2 },
    //     customizeCell: ({ gridCell, excelCell }) => {
    //         if (gridCell.rowType === "data") {
    //             if (gridCell.column.dataField === "image" && gridCell.value) {
    //                 excelCell.value = undefined;

    //                 const image = workbook.addImage({
    //                     base64: gridCell.value,
    //                     extension: "png",
    //                 });

    //                 worksheet.getRow(excelCell.row).height = 90;
    //                 worksheet.addImage(image, {
    //                     tl: { col: excelCell.col - 1, row: excelCell.row - 1 },
    //                     br: { col: excelCell.col, row: excelCell.row },
    //                 })
    //             }
    //         }
    //     },
    // }).then(() => {
    //     workbook.xlsx.writeBuffer().then((buffer) => {

    //     this.dataGrid.columnOption("Present", "visible", false);
    //     this.dataGrid.columnOption("Not Present", "visible", false);
    //     this.dataGrid.columnOption("Out", "visible", false);
    //     this.dataGrid.endUpdate();

    //     saveAs(
    //         new Blob([buffer], { type: "application/octet-stream" }),
    //         "Emergency-Manual-List.xlsx"
    //     );
    //     this.isExport = false;
    //     });
    // });
    // },
    // exportCSV() {
    //     this.dataGrid.beginUpdate();
    //     const workbook = new Workbook();
    //     const worksheet = workbook.addWorksheet("Main sheet");

    //     this.dataGrid.columnOption("Present", "visible", true);
    //     this.dataGrid.columnOption("Not Present", "visible", true);
    //     this.dataGrid.columnOption("Out", "visible", true);

    //     exportDataGrid({
    //         component: this.dataGrid,
    //         worksheet: worksheet,
    //     }).then(() => {
    //         workbook.csv.writeBuffer().then((buffer) => {
    //             this.dataGrid.columnOption("Present", "visible", false);
    //             this.dataGrid.columnOption("Not Present", "visible", false);
    //             this.dataGrid.columnOption("Out", "visible", false);
    //             this.dataGrid.endUpdate();
    //         saveAs(
    //             new Blob([buffer], { type: "application/octet-stream" }),
    //             "Emergency-Manual-List.csv"
    //         );
    //         this.dataGrid.endUpdate();
    //         });
    //     });
    //     // e.cancel = true;
    // },
    // extractedData(type) {
    //     const { rowsData } = this;
    //     const columnNames = this.dataGrid.getVisibleColumns();
    //     const columns = [];
    //     for (let i = 0; i < columnNames.length; i++) {
    //         if (columnNames[i].allowExporting)
    //         columns.push(columnNames[i].dataField);
    //     }
    //     const columnsObject = columns.reduce((a, v) => ({ ...a, [v]: v }), {});
    //     // console.log("columnsObject", columnsObject);
    //     const data = rowsData;
    //     // console.log("extracteddata", rowsData);
    //     return data && data.length > 0
    //         ? data.map((row) => {
    //             ["data", "Data", "Compliances"].forEach((e) => delete row[e]); // reomve unexported columns
    //             // const keys = Object.keys(row);
    //             const filterdRow = {};
    //             columns.forEach((key) => {
    //             if (key in columnsObject) {
    //                 return (filterdRow[key] = row[key]);
    //             }
    //             });

    //             return type == "pdf" ? Object.values(filterdRow) : filterdRow;
    //         })
    //         : [];
    // },
    onSetPdfFont(length) {
      if (length >= 10) {
        return 4;
      } else if (length >= 8) {
        return 6;
      } else {
        return 8;
      }
    },
    reset() {
      this.dataGrid.clearFilter("row");
      this.dataGrid.clearFilter("header");
      this.dataGrid.clearSorting();
      this.showClearAll = false;
    },
    onDataErrorOccurred(e) {
      console.log("onDataErrorOccurred e", e);
      setTimeout(() => {
        let errorRow = document.querySelector(
          ".dx-datagrid-headers .dx-error-message"
        );
        errorRow.innerHTML = this.$t("common.notes.anErrorOccurredGrid");
      }, 100);
    },
  },
  watch: {
    getTableHeaders(value) {
      console.log("watch", value);
    },
    getExportProgessAppearance(value) {
      value && this.$bvModal.show("exportingProgress");
    },
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("emergency", [
      "getGridEmergecyListData",
      "getActiveSessionsData",
    ]),
    ...mapGetters("grid", [
      "getTableHeaders",
      "getTableFilters",
      "getExportProgessAppearance",
      "getVaccinePCRColumnAppearance",
    ]),
    ...mapGetters("authfack", ["userDetails", "currentEntity"]),
    rowsData() {
      // console.log("emergecyListData", this.getGridEmergecyListData);
      return this.emergecyListData && this.emergecyListData.length > 0
        ? this.emergecyListData.map((row) => {
            return {
              user_id: row.user_id,
              image: row.image && row.image != null ? row.image : "",
              fullName:
                row.fullName && row.fullName != null ? row.fullName : "",
              phone: row.phone && row.phone != null ? row.phone : "",
              userType:
                row.userType && row.userType != null ? row.userType : "",
              site: row.site && row.site != null ? row.site : "",
              area: row.area && row.area != null ? row.area : "",
              host:
                row.host && row.host != null
                  ? row.host + " (" + row.userTypeHost + ")"
                  : "-",
              email: row.email && row.email != null ? row.email : "",
              rfid: row.rf_ids?.length ? this.rfidFormatter(row.rf_ids) : null,
              by: "",
              present: "",
              notPresent: "",
              out: "",
            };
          })
        : [];
    },
    dataGrid() {
      return this.$refs[this.dataGridRefName].instance;
    },
    userEmail() {
      return this.userDetails && this.userDetails.email;
    },
    title() {
      return this.$t("emergencyList.grid.title");
    },
  },
  beforeMount() {
    if (this.getLanguage == "ar") {
      this.rtlEnabled = true;
    }
    this.fetchGridEmergencyListData().then(async (data) => {
      // console.log(data);
      this.emergecyListData = data;
      this.gridEmptyMessage = await this.$t('common.grid.noRecordsYet');
      this.dataGrid.endCustomLoading();
    });
    this.fetchActiveSessionsData().then((res) => {
      // console.log('dataaa', data);
      if (res.data && res.data.activeSessions.length > 0) {
        this.activeSessions = res.data.activeSessions.map((session) => {
          if (session.fullName == "default user") session.fullName = "CS";
          return session;
        });
      }
    });
    this.checkVaccinePCRColumnAppearance();
  },
  created() {
    setTimeout(() => {
      this.dataGrid.beginCustomLoading();
    }, 100);

    if (
      this.getVaccinePCRColumnAppearance &&
      this.getVaccinePCRColumnAppearance.scanHost
    ) {
      this.isFlowHasHost = true;
    }

    if (this.getGridEmergecyListData && this.getGridEmergecyListData.data) {
      this.getGridEmergecyListData.data.map((row) => {
        if (row.host && row.host != null) {
          this.isUserHasHost = true;
        }
      });
    }

    // if(this.getActiveSessionsData && this.getActiveSessionsData.length > 0){
    //     this.getActiveSessionsData.map((row) => {
    //         this.activeSessions.push(row);
    //     })
    // }

    document.addEventListener("mousedown", (e) => {
      if (e.path) {
        let isColumnChooser = false;
        for (let i = 0; i < e.path.length; i++) {
          if (typeof e.path[i].matches == "function") {
            if (e.path[i].matches(".dx-overlay-content")) {
              isColumnChooser = true;
            }
          }
        }
        if (!isColumnChooser) this.dataGrid.hideColumnChooser();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
button.btn.d-flex.align-items-center.justify-content-center.text-center.session-btn.btn-primary.btn-sm.rounded-pill {
  margin-inline-start: 40px;
  height: 27px;
  width: 127px;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  text-align: center;

  color: #ffffff;
}
// h6.hint-grid {
//
//   font-style: normal;
//   font-weight: 400;
//   font-size: 14px;
//   line-height: 17px;

//   margin-bottom: 15px !important;
//   color: #939393;
//   margin-inline-start: 30px;

// }

p {
  font-size: 12px;
  color: #b9b7b7;
}

img {
  height: 27px;
  width: 27px;
}

.emergency-list-table {
  tbody {
    color: #495057;
  }
}
</style>

<style lang="scss">
div#emergency-tooltip {
  .tooltip-inner {
    background: #ffffff !important;
    -webkit-box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.161) !important;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.161) !important;
    border-radius: 6px !important;

    font-style: normal;
    font-weight: 400 !important;
    max-width: 137px;
    font-size: 12px !important;
    line-height: 16px !important;
    color: #707070 !important;
    min-width: 20px;
    //margin-top: 45px;
    margin-inline-start: 0px;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  ul {
    margin-bottom: 0px !important;
    text-align: start;
    li.emergency-tool-line {
      background: #ebebeb;
      height: 1px;
      margin-bottom: 9px;
      margin-top: 9px;
    }
  }
}
.active-sessions-con {
  background: #ffffff;
  width: 100%;
  margin-bottom: 16px;
  border-radius: 8px;
  padding: 24px;
  p.active-title {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #4a4a4a;
    margin-bottom: 24px !important;
    padding: 0 !important;
    line-height: 10px;
  }
  .all-active-btns {
    button.first-btn {
      background: #34c38f !important;
      border-radius: 13.5px;
      border: none;
      width: 127px;
      height: 27px;

      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      margin-inline-end: 16px;
      color: #ffffff;
      .tooltip .tooltiptext {
        visibility: hidden;
        width: 300px;
        background-color: red !important;
        color: #fff;
        text-align: center;
        padding: 5px 0;
        border-radius: 6px;
        position: absolute;
        z-index: 1;
      }
    }
    button.second-btn {
      background: #34c38f !important;
      border-radius: 13.5px;
      border: none;
      width: 127px;
      height: 27px;

      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      margin-inline-end: 15px;
      color: #ffffff;
    }
    button.third-btn {
      background: #34c38f !important;
      border-radius: 13.5px;
      border: none;
      width: 127px;
      height: 27px;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      color: #ffffff;
    }
  }
}
div#gridContainerr {
  .dx-datagrid {
    height: calc(100vh - 231px);
  }
  .dx-datagrid-headers .dx-datagrid-table .dx-row > td {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #939393;
  }
}

.tooltip .arrow {
  display: none !important;
}

.emergency-list-white-bg-sec {
  background-color: white;
  padding-inline-start: 0px;
  //   padding-top: 25px;
  border-radius: 8px !important;
  .custom-control-label {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-inline-start: 8px;
    height: 20px;
  }
  .custom-control-label::before {
    border: 2px solid #103f5e !important;
    width: 20px;
    height: 20px;
  }
  .custom-control-label span {
    position: relative;
    top: 0px !important;
  }
}
[aria-label="Column RFID"] {
  .dx-sort.dx-sort-up,
  .dx-sort.dx-sort-down {
    display: none !important;
  }
}
</style>
